import { NextSeo } from 'next-seo'

import { langs } from './langs'
import { DefaultImage } from '@/service/types'

type HeadTagProps = {
  title: string
  description: string
  languageOptions: string[]
  path: string
  image?: DefaultImage
}

export const HeadTag: React.FC<HeadTagProps> = ({
  title,
  description,
  languageOptions,
  path,
  image,
}) => {
  languageOptions.push('x-default')

  const linkTags =
    languageOptions &&
    languageOptions.map((lang) => {
      const href =
        'https://www.natahouse.com' +
        `${lang !== 'x-default' ? `/${lang}` : ''}` +
        `${path}`

      return {
        rel: 'alternate',
        href,
        hrefLang: langs[lang] || 'x-default',
      }
    })

  return (
    <NextSeo
      title={title}
      description={description}
      additionalLinkTags={linkTags}
      openGraph={{
        images: image?.url
          ? [
              {
                url: image?.url || '',
                alt: image?.alternativeText,
                height: image?.height,
                width: image?.width,
              },
            ]
          : [],
      }}
    />
  )
}
